import _ from "lodash";

export default {
  sourceList: (state) => {
    return state.sources;
  },
  sourceItem: (state) => {
    return state.sourceItem;
  },
  customSourceItem: (state) => {
    return state.sourceItem;
  },
  totalCount: (state) => {
    return state.count;
  },
  currentPage: (state) => {
    return state.pagination.page;
  },
  pageCount: (state) => {
    return Math.ceil(state.count / state.pagination.rowPerPage);
  },
  limit: (state) => {
    return state.pagination.rowPerPage;
  },
  offset: (state) => {
    return (state.pagination.page - 1) * state.pagination.rowPerPage;
  },
  filters: (state) => {
    return state.filters;
  },
  formattedFilters: (state) => {
    let filters = {};
    _.forIn(state.filters, function (value, key) {
      if (value !== null && (!(value instanceof Array) || value.length)) {
        if (value.length - 1 && value instanceof Array) {
          filters[key] = value.join(",");
        } else {
          filters[key] = value;
        }
      }
    });
    return filters;
  },
  sourceTags: (state) => {
    return state.sourceTags;
  },
  formattedSort: (state) => {
    let formatted = state.sort.sortBy;
    if (state.sort.desc) {
      return `-${formatted}`;
    }
    return formatted;
  },
};
